const Public = {
	//加密
	encode(str) {
		return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
			function toSolidBytes(match, p1) {
				return String.fromCharCode('0x' + p1);
			}));
	},
	//解密
	decode(str) {
		// Going backwards: from bytestream, to percent-encoding, to original string.
		// return decodeURIComponent(str)
		return decodeURIComponent(atob(str).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	},
	link(item){
		console.log(item)
		// if(item.resourceType == 1){  //图片
					if(item.jumpState == '1'){
						if(item.jumpUri!=''){
							window.open(item.jumpUri)
						}
					}
		// }else{  //视频

		// }
	},
	// getConsole(value){
	// 	if(process.env.VUE_APP_ENV == 'test'){
	// 		return 'console.log(' + value + ')'
	// 	}else {
	// 		return '//console.log(' + value + ')'
	// 	}
	// 	// console.log
	// }
}
export default Public
